export type PaymentPartsIconProps = {
  icon: {
    paymentsCount: number;
    systemId: number;
    content: string;
  }
};

const PaymentPartsIcon = ({
  icon
}: PaymentPartsIconProps): JSX.Element => {
  const rawMarkup = () =>{
    return { __html: icon.content };
  }

  return(
    <div className="modal-body">
      <span dangerouslySetInnerHTML={rawMarkup()} />
    </div>
  )
};

export default PaymentPartsIcon